const onFetchSuccess = async (
  res,
  setData,
  data,
  onSuccess,
  setSuccessMessage,
  successText
) => {
  const contentType = res.headers.get('content-type')
  const isData = contentType && contentType.indexOf('application/json') !== -1

  if (isData) {
    const response = await res.json()
    onSuccess && onSuccess(data, setData, response)
  } else {
    onSuccess && onSuccess(data, setData)
  }
  setSuccessMessage({ successMessage: successText })
}

export default onFetchSuccess
